import Popper from "@material-ui/core/Popper";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import React from "react";
import { connect } from "react-redux";
import {
  addAttribute
} from "../../../../Actions/Form";

const HouseOverview = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const closePopper = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <div onMouseLeave={closePopper}>
        <React.Fragment>
          {props.form.selectedHouse &&
            props.form.selectedHouse.ID === props.data.ID && (
              <Popper open={open} anchorEl={anchorEl}>
                <div
                  className="menu-container"
                  onMouseLeave={() => closePopper(false)}
                  style={{
                    marginLeft: "-175px",
                    marginTop: "0px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="menu-options"
                    onClick={() => {
                      closePopper("bottom-end");
                      props.showAddHouse(props.data);
                    }}
                  >
                    {props.form.language.EDIT}
                  </div>
                  <div
                    className="menu-options"
                    onClick={() => {
                      closePopper("bottom-end");
                      props.handleRequest("delete", props.data.ID);
                      props.addAttribute({
                        name: "selectedHouse",
                        value: {},
                      });
                    }}
                  >
                    {props.form.language.DELETE}
                  </div>
                </div>
              </Popper>
            )}
        </React.Fragment>

        <div className="overviewContainer">
          <div
            className="overviewMenu"
            onClick={(event) => {
              handleClick(event);
              props.addAttribute({
                name: "selectedHouse",
                value: props.data,
              });
            }}
          >
            <MoreHorizIcon className='show-menu-icon' />
          </div>
          <div
            className="momentio-text-bold"
            style={{ marginTop: "-5px", width: "100%" }}
          >
            <div style={{ display: "flex" }} className="input-container-column">
              <div
                className="accordion-content-option-label header24Medium"
                style={{ marginBottom: "10px" }}
              >
                {props.data.houseType === "rental"
                  ? props.form.language.HOUSE_RENTAL
                  : props.data.houseType === "private"
                  ? props.form.language.HOUSE_OWN
                  : ""}
              </div>
            </div>
            {props.data.houseType === "rental" && (
              <div style={{ display: "flex" }} className="input-container-column">
                <div className="momentio-text-normal accordion-content-option-label">
                  {props.form.language.LANDLORD_NAME}
                </div>
                <div className="momentio-text-bold" style={{ width: "70%" }}>
                  {props.data.rentee}
                </div>
              </div>
            )}
            {props.data.houseType === "private" && (
              <div style={{ display: "flex" }} className="input-container-column">
                <div className="momentio-text-normal accordion-content-option-label">
                  {props.form.language.MORGAGE_COMPANY}
                </div>
                <div className="momentio-text-bold" style={{ width: "70%" }}>
                  {props.data.mortgager}
                </div>
              </div>
            )}
            {props.data.houseType === "private" && (
              <div style={{ display: "flex" }} className="input-container-column">
                <div className="momentio-text-normal accordion-content-option-label">
                  {props.form.language.POLICY_NUMBER}
                </div>
                <div className="momentio-text-bold" style={{ width: "70%" }}>
                  {props.data.polisNumber}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addAttribute: (payload) => dispatch(addAttribute(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HouseOverview);
